import { useParams } from 'react-router-dom';
import 'video.js/dist/video-js.css';
import logger from 'Core-utils/logger';
import { useHmacValidation } from './hooks/useHmacValidation';
import { useVideoPlayer } from './hooks/useVideoPlayer';
import { useVideoCompletion } from './hooks/useVideoCompletion';
import { useI18n } from 'Hooks/useI18n';
import Antenna from 'Assets/gif/Antenna.gif';
import './styles.scss';

const VideoPlayerPage = () => {
    const { id } = useParams<{ id: string }>();
    const hash = id;
    const { t, loading: i18nLoading } = useI18n();
    const { videoUrl, hmacValidated } = useHmacValidation(hash);
    const { videoCompleted, markVideoCompleted } = useVideoCompletion(hash);
    const { videoRef, isLoading } = useVideoPlayer({
        videoUrl,
        hmacValidated,
        hash,
        onVideoEnded: markVideoCompleted,
    });

    const missingTrainingContent = () => {
      return (
        <div className="video-player-page">
          <div className="video-player-page__error">
              <h2>{t('COMPLIANCE_TRAINING_MISSING_TRAINING_ID_TITLE')}</h2>
              <p>{t('COMPLIANCE_TRAINING_MISSING_TRAINING_ID_DETAIL')}</p>
          </div>
        </div>
      );
    };

    const i18nLoadingContent = () => {
      return (
        <div className="video-player-page">
          <div className="video-player-page__loading">
            <img src={Antenna} alt="loading" />
          </div>
        </div>
      );
    };

    if (i18nLoading) {
        return i18nLoadingContent();
    }
    if (!hash) {
        return missingTrainingContent();
    }
    return (
        <div className="video-player-page" data-testid="video-player-page">
            <div className="video-player-page__container">
                <div className="video-player-page__player-wrapper">
                    {isLoading && (
                        <div className="video-player-page__loading">
                            <p>{t('COMPLIANCE_TRAINING_LOADING_VIDEO')}</p>
                        </div>
                    )}
                    <video
                        ref={(el) => {
                            logger.log('Video ref callback', {
                                element: el ? 'exists' : 'null',
                                id: el?.id,
                                className: el?.className,
                                parentNode: el?.parentNode ? 'exists' : 'null',
                            });
                            videoRef.current = el;
                            if (el) {
                                // Ensure element has an ID for Video.js
                                if (!el.id) {
                                    el.id = `video-player-${Date.now()}`;
                                    logger.log('Assigned ID to video element', el.id);
                                }
                            }
                        }}
                        className="video-js vjs-big-play-centered"
                        playsInline
                    >
                        {videoUrl && <source src={videoUrl} type="video/mp4" />}
                        <p className="vjs-no-js vjs-hidden">
                            {t('COMPLIANCE_TRAINING_VIDEO_PLAYER_NO_JS_MESSAGE')}
                        </p>
                    </video>
                </div>
                {videoCompleted && (
                    <div className="video-player-page__completion-message">
                        <p>{t('COMPLIANCE_TRAINING_VIDEO_PLAYER_COMPLETION_MESSAGE_TITLE')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideoPlayerPage;
